// extracted by mini-css-extract-plugin
module.exports = {"nudgesContainer":"style_nudgesContainer__1dFZV","createNudgeFab":"style_createNudgeFab__Ljom5","fabLoader":"style_fabLoader__2p4Dt"};